import { render } from "./SchedaAzienda.vue?vue&type=template&id=3e15f9ea&scoped=true"
import script from "./SchedaAzienda.vue?vue&type=script&lang=js"
export * from "./SchedaAzienda.vue?vue&type=script&lang=js"

import "./SchedaAzienda.vue?vue&type=style&index=0&id=3e15f9ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e15f9ea"]])

export default __exports__